import { ComponentType } from 'react';
import { SKIN } from '../../types/enums';
import { createSkinComponent } from '../../utils/skinComponent';
import { SIDEBAR_OPTION, SidebarType } from '../sidebar';

import BettingDrawerContent from '../../components/molecules/sidebar/BettingDrawerContent';
import InPlaySportSidebar from '../../components/molecules/sidebar/InPlaySportSidebar';
import DefaultInPlayMatchSidebar from '../../components/molecules/sidebar/InPlayMatchSidebar';
import AccountDrawerContent from '../../components/molecules/sidebar/AccountDrawerContent';
import GolaBettingDrawerContent from '../../components/skins/gola/molecules/BettingDrawerContent';
import GolaInPlaySportSidebar from '../../components/skins/gola/molecules/InPlaySportSidebar';
import GolaAccountDrawerContent from '../../components/skins/gola/molecules/AccountDrawerContent';
import NeobetBettingDrawerContent from '../../components/skins/neobet/molecules/BettingDrawerContent';
import NeobetAccountDrawerContent from '../../components/skins/neobet/molecules/AccountDrawerContent';

export const SportsSidebar = createSkinComponent(BettingDrawerContent, {
  [SKIN.GOLA]: GolaBettingDrawerContent,
  [SKIN.NEOBET]: NeobetBettingDrawerContent,
});

export const InPlaySidebar = createSkinComponent(InPlaySportSidebar, {
  [SKIN.GOLA]: GolaInPlaySportSidebar,
  [SKIN.NEOBET]: NeobetBettingDrawerContent,
});

export const InPlayMatchSidebar = createSkinComponent(DefaultInPlayMatchSidebar, {
  [SKIN.GOLA]: GolaInPlaySportSidebar,
  [SKIN.NEOBET]: NeobetBettingDrawerContent,
});

export const AccountSidebar = createSkinComponent(AccountDrawerContent, {
  [SKIN.GOLA]: GolaAccountDrawerContent,
  [SKIN.NEOBET]: NeobetAccountDrawerContent,
});

export const SIDEBAR_COMPONENTS: Record<SidebarType, ComponentType> = {
  [SIDEBAR_OPTION.SPORTS]: SportsSidebar,
  [SIDEBAR_OPTION.IN_PLAY]: InPlaySidebar,
  [SIDEBAR_OPTION.IN_PLAY_MATCH]: InPlayMatchSidebar,
  [SIDEBAR_OPTION.ACCOUNT]: AccountSidebar,
};
